module.exports = __webpack_public_path__ + "static/media/HCMM559.5ed6f72d.jpg";